export default __webpack_public_path__ + "static/st-tablet-980d29e6ab5a428fac24c9fc61c072a0.png";